import store from '@/store/'

const canAccess = (allowedRoles = [], deniedRoles = []) => {
  const userType = store.getters['user/type']
  const isPermitted = allowedRoles.length === 0 || allowedRoles.includes(userType)
  const isDenied = deniedRoles.includes(userType)
  return isPermitted && !isDenied
}

const isTopBrandAdmin = () => {
  const userType = store.getters['user/type']
  const parentType = store.state.user.parent_user

  const isBrandAdmin = userType === 'brand-admin' && parentType === null
  const isTrafficManagerFromParent = parentType?.type === 'traffic-manager'
  const isBrandEmployee = userType === 'brand-employee' && parentType === null
  const isTrafficManagerFromGrandParent = parentType?.parent_type === 'traffic-manager'
  const isTopBrandAdmin = isBrandAdmin || isTrafficManagerFromParent || isBrandEmployee || isTrafficManagerFromGrandParent

  return isTopBrandAdmin
}

export const checkAccessActionSB = async ({ from, next, router, to }) => {
  if (canAccess(['agency', 'agency-employee', 'employee']) || isTopBrandAdmin()) {
    return next()
  } else {
    router.push('/404')
  }
}
